import React from 'react';

const CountyContext = React.createContext({
  county: null,
  setCounty: (value) => { },
  countyCode: null,
  setCountyCode: (value) => { },
  countyData: null,
  setCountyData: (value) => { },
});

export default CountyContext;
